<template>
  <div class="sample-detail-billing-info">
    <h3>Billing Information</h3>
    <section>
      <div class="form-group flex-group multiple-texts">
        <div class="form-field form-checkbox">
          <input id="isBillable" class="k-checkbox" type="checkbox" v-model="sampleData.isBillable" tabindex="400" />
          <label class="k-checkbox-label" for="isBillable">Billable</label>
        </div>
        <AutoComplete
          :formData="sampleData"
          :mapping="mappings.ThirdParty"
          store="ThirdParty"
          :tabindex="401"
          :allowAdditions="true"
          placeholder="Third Party"
        />
        <div class="form-field form-checkbox">
          <input
            id="isBasicSample"
            type="checkbox"
            class="k-checkbox"
            v-model="sampleData.isBillingBasicSample"
            tabindex="402"
          />
          <label class="k-checkbox-label" for="isBasicSample">Basic Sample</label>
        </div>
      </div>
    </section>
    <div class="form-group billing-checks" v-if="sampleData.isBillable">
      <div class="checkbox-row">
        <div class="form-field form-checkbox checkbox-col">
          <input id="st" type="checkbox" class="k-checkbox" v-model="sampleData.isBillingSt" tabindex="403" />
          <label class="k-checkbox-label" for="st">ST</label>
        </div>
        <div class="form-field form-checkbox checkbox-col">
          <input id="pt" type="checkbox" class="k-checkbox" v-model="sampleData.isBillingPt" tabindex="404" />
          <label class="k-checkbox-label" for="pt">PT</label>
        </div>
        <div class="form-field form-checkbox checkbox-col">
          <input id="nc" type="checkbox" class="k-checkbox" v-model="sampleData.isBillingNc" tabindex="405" />
          <label class="k-checkbox-label" for="nc">NC</label>
        </div>
        <div class="form-field form-checkbox checkbox-col">
          <input id="nob" type="checkbox" class="k-checkbox" v-model="sampleData.isBillingNob" tabindex="406" />
          <label class="k-checkbox-label" for="nob">NOB</label>
        </div>
        <div class="form-field form-checkbox checkbox-col">
          <input id="rush" type="checkbox" class="k-checkbox" v-model="sampleData.isBillingRush" tabindex="407" />
          <label class="k-checkbox-label" for="rush">RUSH</label>
        </div>
      </div>
    </div>
    <br />
    <div v-if="sampleData.isBillable" class="form-field flex-group form-group top-align">
      <label class="k-textbox-label" for="billingDesc">Billing Description</label>
      <textarea v-model="sampleData.billingDescription" id="billingDesc" class="k-textarea" tabindex="408"> </textarea>
    </div>
  </div>
</template>

<script>
import AutoComplete from '../../shared/AutoComplete.vue';

export default {
  name: 'SampleDetailBillingInfo',
  data() {
    return {};
  },
  props: {
    sampleData: {
      type: Object,
      required: true
    },
    mappings: {
      type: Object,
      required: true
    }
  },
  components: {
    AutoComplete
  }
};
</script>
<style lang="scss" scoped>
section {
  border-color: $black;
  border-style: dotted;
  border-width: 0 0 1px;
  margin-bottom: 10px;
  padding-bottom: 10px;
}

.billing-checks,
section {
  padding-left: 131px;
}

.checkbox-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

.checkbox-col {
  display: flex;
  flex: 1;
  flex-direction: column;
}
</style>
